/* ==========================================================================
   MOVIMENTO — Kreo per FITTAMI, 17 settembre 2026
   --------------------------------------------------------------------------
   Regole che questo file rispetta, e che non vanno aggirate:

   1. Le animazioni partono ALL'ARRIVO sulla sezione, mai al caricamento.
   2. Senza JavaScript la pagina resta leggibile: la classe k-js viene messa
      da qui, e tutte le regole di movimento sono scritte sotto quella classe.
      Niente JS, niente classe, niente elementi nascosti.
   3. NON si usa IntersectionObserver. Sembra la scelta giusta ed e' la
      scelta sbagliata per noi: l'osservatore non consegna le notifiche
      quando la pagina viene scorsa da un programma, ed e' cosi' che si
      girano i video del prima/dopo. Misurato il 17 settembre 2026 sulla
      pagina di concetto: con l'osservatore, in ripresa, 8 fotografie su 8
      restavano invisibili. Qui si legge la posizione durante lo scorrimento.
   ========================================================================== */
(function () {
  var radice = document.documentElement;
  radice.classList.add('k-js');

  var fermo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- i titoli si spezzano in parole, che salgono una per volta ---- */
  document.querySelectorAll('.k-titolone').forEach(function (t) {
    if (t.dataset.kSpezzato) return;
    var html = '', i = 0;
    Array.prototype.forEach.call(t.childNodes, function (n) {
      var acceso = n.nodeType === 1 && (n.tagName === 'EM' || n.tagName === 'SPAN');
      (n.textContent || '').split(/(\s+)/).forEach(function (w) {
        if (!w.trim()) { if (w) html += ' '; return; }
        html += '<span class="k-parola" style="--i:' + (i++) + '">' +
                '<span' + (acceso ? ' class="k-acceso"' : '') + '>' + w + '</span></span>';
      });
    });
    if (i) { t.innerHTML = html; t.dataset.kSpezzato = '1'; }
  });

  /* ---- il marchio: le ultime tre lettere in arancione ----
     Il nome del negozio arriva come testo, non come markup: qui si divide.
     Se il nome cambia, cambia da solo anche questo. */
  (function () {
    var l = document.querySelector('.header__heading-link');
    if (!l || l.dataset.kMarchio) return;
    var n = l.querySelector('.h2') || l;
    var t = (n.textContent || '').trim();
    if (t.length < 4) return;
    var coda = t.slice(-3), testa = t.slice(0, -3);
    n.innerHTML = testa + '<span class="k-marchio-coda">' + coda + '</span>';
    l.dataset.kMarchio = '1';
  })();

  /* ---- che cosa aspetta di comparire ---- */
  var daSvelare = [].slice.call(document.querySelectorAll('.k-riv,.k-tenda,.k-titolone'));
  var daContare = [].slice.call(document.querySelectorAll('[data-k-conta]'));

  /* Alcune parti della pagina arrivano dopo il caricamento: i prodotti
     abbinati alla scheda li porta il negozio con una chiamata sua. Se nessuno
     le annuncia restano invisibili per sempre, perche' l'elenco di chi deve
     comparire e' stato letto una volta sola. */
  window.kreoRiguarda = function () {
    document.querySelectorAll('.k-riv,.k-tenda,.k-titolone').forEach(function (el) {
      if (!el.classList.contains('k-vista') && daSvelare.indexOf(el) < 0) daSvelare.push(el);
    });
    document.querySelectorAll('[data-k-conta]').forEach(function (el) {
      if (daContare.indexOf(el) < 0) daContare.push(el);
    });
    controlla();
  };

  function dentro(el, quota) {
    var r = el.getBoundingClientRect();
    return r.top < innerHeight * quota && r.bottom > 0;
  }

  function svela(el) {
    el.classList.add('k-vista');
    if (el.classList.contains('k-titolone')) {
      el.querySelectorAll('.k-parola').forEach(function (p) { p.classList.add('k-vista'); });
    }
  }

  function conta(el) {
    var meta = parseFloat(el.dataset.kConta),
        dec  = parseInt(el.dataset.kDecimali || '0', 10),
        t0   = null;
    if (fermo) { el.textContent = meta.toFixed(dec); return; }
    requestAnimationFrame(function passo(t) {
      if (!t0) t0 = t;
      var q = Math.min((t - t0) / 1100, 1);
      el.textContent = (meta * (1 - Math.pow(1 - q, 3))).toFixed(dec);
      if (q < 1) requestAnimationFrame(passo);
    });
  }

  var barra = document.querySelector('.k-avanzamento');
  var passi = [].slice.call(document.querySelectorAll('.k-scaletta .k-passo'));
  var filo  = document.querySelector('.k-filo-vivo');

  function controlla() {
    daSvelare = daSvelare.filter(function (el) {
      if (!dentro(el, 0.88)) return true;
      svela(el); return false;
    });
    daContare = daContare.filter(function (el) {
      if (!dentro(el, 0.8)) return true;
      conta(el); return false;
    });

    if (barra) {
      var h = document.documentElement.scrollHeight - innerHeight;
      barra.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')';
    }

    /* la testata si stacca dal fondo appena si scorre */
    radice.classList.toggle('k-scorso', scrollY > 10);

    /* il Metodo si accende un passo alla volta, e il filo si riempie dietro */
    if (passi.length && filo) {
      var accesi = 0;
      passi.forEach(function (p) {
        if (dentro(p, 0.62)) { p.classList.add('k-acceso-passo'); accesi++; }
      });
      filo.style.height = (accesi / passi.length * 100) + '%';
    }

    /* parallasse: solo sugli elementi che lo chiedono, e solo finche' sono
       vicini alla prima schermata — piu' giu' e' lavoro sprecato */
    if (!fermo && scrollY < innerHeight * 1.4) {
      document.querySelectorAll('[data-k-parallasse]').forEach(function (el) {
        var f = parseFloat(el.dataset.kParallasse) || 0.26;
        el.style.transform = 'translateY(' + (scrollY * f) + 'px)';
      });
    }
  }

  addEventListener('scroll', controlla, { passive: true });
  addEventListener('resize', controlla, { passive: true });
  addEventListener('load', controlla);
  controlla();
  /* le immagini che arrivano dopo cambiano le altezze: si ricontrolla */
  setTimeout(controlla, 400);
  setTimeout(controlla, 1200);

  /* ---- il quiz: una scelta per domanda ----
     Il passaggio da una domanda all'altra lo governa la sezione del quiz, che
     deve anche decidere quando mostrare il box: se lo facesse anche questo
     file, due mani muoverebbero la stessa cosa e il risultato comparirebbe
     mentre si sta ancora rispondendo. Qui resta solo la scelta. */
  document.querySelectorAll('[data-k-quiz]').forEach(function (q) {
    q.querySelectorAll('.k-scelte').forEach(function (gruppo) {
      gruppo.querySelectorAll('.k-scelta').forEach(function (s) {
        s.addEventListener('click', function () {
          gruppo.querySelectorAll('.k-scelta').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          s.setAttribute('aria-pressed', 'true');
        });
      });
    });
  });

  /* ---- gruppi a linguette (categorie, e tutto quello che verra' dopo) ----
     I pannelli non aperti sono nascosti, e una fotografia "pigra" dentro
     qualcosa di nascosto non viene scaricata mai: al primo clic su un'altra
     categoria partiva lo scaricamento in quel momento, e i prodotti
     comparivano dopo un'attesa o non comparivano affatto.
     Appena il gruppo arriva sullo schermo si tolgono le pigrizie a tutte le
     fotografie dei pannelli chiusi: cosi' arrivano prima che servano. */
  document.querySelectorAll('[data-k-linguette]').forEach(function (gruppo) {
    function scalda() {
      gruppo.querySelectorAll('[role="tabpanel"][hidden] img[loading="lazy"]').forEach(function (i) {
        i.loading = 'eager';
        if (!i.getAttribute('src') && i.dataset.src) { i.src = i.dataset.src; }
      });
    }
    if ('IntersectionObserver' in window) {
      var occhio = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { if (v.isIntersecting) { scalda(); occhio.disconnect(); } });
      }, { rootMargin: '400px' });
      occhio.observe(gruppo);
    } else {
      window.addEventListener('load', scalda);
    }

    var tasti = gruppo.querySelectorAll('[role="tab"]');
    tasti.forEach(function (b) {
      b.addEventListener('click', function () {
        tasti.forEach(function (x) {
          x.setAttribute('aria-selected', 'false');
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
        b.setAttribute('aria-selected', 'true');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) { p.hidden = false; p.style.animation = 'none'; void p.offsetHeight; p.style.animation = ''; }
      });
    });
  });
})();
